angular.module('picmonic-common').factory('SalesforceResource', [
  '$resource',
  function ($resource) {
    return $resource('/api/v2/salesforce/:resource', { resource: '@resource' });
  },
]);
